import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { uz } from "../translations/uz";
import { ru } from "../translations/ru";

// UZ primary + fallback. RU is a placeholder pass (translations/ru.ts). No URL/lang
// detector for this internal panel — operators work in Uzbek; RU kept ready for later.
i18n.use(initReactI18next).init({
  resources: {
    uz: { translation: uz },
    ru: { translation: ru },
  },
  lng: "uz",
  fallbackLng: "uz",
  interpolation: { escapeValue: false },
  react: { useSuspense: false },
});

export default i18n;
